// PE-6108 — returning patient appointment confirmation email body

import {
  applyMergeFields,
  buildOptionalParagraphBlock,
  buildTenantDepartmentBlock,
  escapeHtml,
} from './appointment-email-html.util';
import { RETURNING_PATIENT_APPOINTMENT_EMAIL_TEMPLATE } from './returning-patient-appointment-email.template';

interface AppointmentConfirmationEmailBaseFields {
  patientName: string;
  appointmentType: string;
  providerName: string;
  appointmentDate: string;
  appointmentTime: string;
  appointmentLocation: string;
  contactPhone: string;
  additionalNotes?: string;
}

export interface ReturningPatientAppointmentEmailFields extends AppointmentConfirmationEmailBaseFields {
  tenantName: string;
  departmentName: string;
}

function buildAppointmentDetailMergeFields(
  fields: AppointmentConfirmationEmailBaseFields
): Record<string, string> {
  return {
    patientName: escapeHtml(fields.patientName),
    appointmentType: escapeHtml(fields.appointmentType),
    providerName: escapeHtml(fields.providerName),
    appointmentDate: escapeHtml(fields.appointmentDate),
    appointmentTime: escapeHtml(fields.appointmentTime),
    appointmentLocation: escapeHtml(fields.appointmentLocation),
    contactPhone: escapeHtml(fields.contactPhone),
    additionalNotesBlock: buildOptionalParagraphBlock(fields.additionalNotes),
  };
}

export function buildReturningPatientAppointmentEmailBody(
  fields: ReturningPatientAppointmentEmailFields
): string {
  const safe = {
    ...buildAppointmentDetailMergeFields(fields),
    preheaderText: escapeHtml(
      'Your appointment has been scheduled. View your appointment details.'
    ),
    tenantDepartmentBlock: buildTenantDepartmentBlock(fields.tenantName, fields.departmentName),
  };

  return applyMergeFields(RETURNING_PATIENT_APPOINTMENT_EMAIL_TEMPLATE, safe);
}
